import axios from 'axios'
import { initComplaintsWidget } from './init'

axios.defaults.baseURL = 'https://liga.zvonok.com'

document.addEventListener('DOMContentLoaded', initComplaintsWidget)
